/**
 * @desc 作废报价明细
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  params: API.tms.logisticsQuotationDetailTob.cancelLogisticsQuotationDetail.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsQuotationDetailTob/cancelLogisticsQuotationDetail`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
